import _, { forIn } from 'lodash-es';

export const distributionDataOptions = (data) => {
  console.log('==++-==',data)
  const x_data = [];
  const signAmount_data = [];
  const refundAmount_data = [];
  const colors = ['#063050', '#73C0DE', '#FAC858', '#8d4bbb'];

  let index = 0;
  forIn(data, (value, key) => {
    x_data.push(value.name);
    signAmount_data.push({
      value: value.newSignAmount || 0,
      itemStyle: { color: colors[index % colors.length] }
    });
    refundAmount_data.push({
      value: value.refundAmount || 0,
      itemStyle: { color: '#FF0000' }
    });
    index++;
  })

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    // legend: {
    //   data: ['退款金额'],
    //   top: 0
    // },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '12%',
      top: '12%',
      containLabel: true
    },
    color: colors,
    xAxis: [
      {
        type: 'category',
        data: x_data,
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: { interval: 0, rotate: 22 }
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        name: '签约金额',
        type: 'bar',
        barWidth: '35%',
        data: signAmount_data,
        label: {
          show: true,
          position: 'top',
          formatter: '{c}'
        }
      },
      {
        name: '退款金额',
        type: 'bar',
        barWidth: '35%',
        color: '#FF0000',
        data: refundAmount_data,
        label: {
          show: true,
          position: 'top',
          formatter: '{c}'
        }
      }
    ]
  }
};
